import "./PortfolioHotelsWeManage.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import HotelPortfolioGallery from "./sections/HotelPortfolioGallery";
import Partnership from "./sections/Partnership";
import Hotelpartnerfaq from "./sections/Hotelpartnerfaq";
import RevenuePartnership from "./sections/RevenuePartnership";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioHotelsWeManagePage() {
  return <div>
      <Header />
      <Hero />
      <HotelPortfolioGallery />
      <Partnership />
      <Hotelpartnerfaq />
      <RevenuePartnership />
      <Footer />
    </div>;
}